import { isEmpty, trim } from 'lodash'

export function getAuthenticityToken() {
  return document.querySelector('meta[name=csrf-token]').content
}

export function isBlank(string) {
  return isEmpty(trim(string))
}
